import Images from 'app/assets/img';
import { ReactComponent as BedIcon } from 'app/assets/img/icon_bed.svg';
import { ReactComponent as FlightIcon } from 'app/assets/img/icon_plane.svg';
import { ReactComponent as LeadingIcon } from 'app/assets/img/iconLeading.svg';
import { ReactComponent as ArrowRightIcon } from 'app/assets/img/right_arrow.svg';
import StyledCollapse, {
  CollapsePanelWrapper,
} from 'app/components/StyledCollapse';
import {
  FareFamilyData,
  FareFamilyRuleItem,
  getFareFamilyByFareBasis,
} from 'app/services/fareFamilyApi';
import _ from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { renderReplaceText } from 'utils/helper';
import { selectTranslations } from '../App/slice/selectors';
import { formatDate } from '../BookingMask';
import { calculateHotelNights } from '../BookingMask/bookingMask.helpers';
import DialogFlightInformation from './DialogFlightInformation';
import DialogHotelDetail from './DialogHotelDetail';
import useWindowSize from 'app/hooks/useWindowSize';
interface IFlightInformationProps {
  flightInfo: any;
  comboInfo: any;
  hotelInfo?: any;
  dataAirports?: any;
  fareFamilies: FareFamilyData[];
  note?: string;
}
const FALLBACK_IMAGE = Images.ImgBanner;
const FlightInformation: React.FC<IFlightInformationProps> = props => {
  const {
    flightInfo: dataFlight,
    comboInfo: dataCombo,
    hotelInfo: dataHotelInfo,
    dataAirports,
    fareFamilies,
    note = '',
  } = props;
  const { device } = useWindowSize();
  const isMobile = device === 'mobile';
  const translations = useSelector(selectTranslations);
  const [isShowInfo, setIsShowInfo] = useState<boolean>(false);
  const [isShowHotelInfo, setIsShowHotelInfo] = useState<boolean>(false);
  const formatShortAirport = (
    code?: string,
    isReturnObject: boolean = false,
  ) => {
    const cityName = dataAirports?.find(el => el.code === code)?.cityName || '';
    const nameAirport =
      cityName && code
        ? `${cityName} (${code})`
        : cityName || `(${code})` || '';
    if (isReturnObject) {
      return {
        cityName,
        nameAirport,
        code,
      };
    }
    return nameAirport;
  };
  const onCloseDialog = () => {
    setIsShowInfo(false);
  };
  const onClickViewDetailFlight = () => {
    setIsShowInfo(true);
  };
  const onCloseDialogHotel = () => {
    setIsShowHotelInfo(false);
  };
  const onClickViewDetailHotel = () => {
    setIsShowHotelInfo(true);
  };
  const getAllFareRules = flight => {
    const fareBasis = flight.fareBasis || '';
    const cabinId = undefined;
    if (fareBasis && fareFamilies.length > 0) {
      const fareFamily = getFareFamilyByFareBasis(
        fareBasis,
        fareFamilies,
        cabinId,
      );
      if (fareFamily && fareFamily.fareFamilyRules?.length > 0) {
        const flightOrigin = flight.departure || '';
        const flightDestination = flight.arrival || '';
        const activeRulesForRoute = fareFamily.fareFamilyRules.filter(
          r =>
            r.status === 1 &&
            r.departureCode === flightOrigin &&
            r.arriveCode === flightDestination,
        );
        const uniqueRules = activeRulesForRoute.reduce((acc, rule) => {
          if (!acc.find(r => r.fareRuleId === rule.fareRuleId)) {
            acc.push(rule);
          }
          return acc;
        }, [] as FareFamilyRuleItem[]);

        return {
          cabinId: fareFamily.cabinId || undefined,
          cabinName: fareFamily.cabinName || '',
          class: fareFamily.name || '',
          rules: uniqueRules,
        };
      }
    }
    return {
      class: '',
      cabinId: undefined,
      cabinName: '',
      rules: [],
    };
  };
  const firstHotel = dataHotelInfo?.[0] || {};
  const checkin = firstHotel?.checkInDate;
  const checkout = firstHotel?.checkOutDate;
  const hotelNights =
    checkin && checkout && calculateHotelNights(checkin, checkout);
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = FALLBACK_IMAGE;
  };
  return (
    <BoxContainerCollapse>
      <StyledCollapse defaultActiveKey="">
        <CollapsePanelWrapper
          className={`collapseItem ${isMobile ? 'comboCollapseMobile' : ''}`}
          key={1}
          header={
            <div className="boxLeftHeaderCollapse">
              <div className="boxIcon">
                <FlightIcon width={20} height={20} />
              </div>
              <div>
                <Title>
                  {formatShortAirport(dataFlight?.[0]?.departure)}&nbsp;&nbsp;
                  <i
                    className={`fa-solid ${
                      dataFlight?.length > 1
                        ? 'fa-arrow-right-arrow-left'
                        : 'fa-arrow-right'
                    }`}
                    style={{ fontSize: 12 }}
                  />
                  &nbsp;&nbsp;
                  {formatShortAirport(dataFlight?.[0]?.arrival)}
                </Title>
                <SubTitle>
                  {
                    translations?.[
                      dataFlight?.length > 1
                        ? 'b2b.txt.roundTrip'
                        : 'b2b.txt.oneWay'
                    ]
                  }
                </SubTitle>
              </div>
            </div>
          }
        >
          <div className="boxContentCollapse">
            {dataFlight?.map((flight, index) => {
              const allFareRules = getAllFareRules(flight);
              return (
                <ItemLeg key={index}>
                  <div className="txtLeg">
                    {index === 0
                      ? translations?.['b2b.txt.departureLeg']
                      : translations?.['b2b.txt.returnLeg']}
                  </div>
                  <div className="legContent">
                    <span>
                      {formatDate(moment(flight.departureTime), translations)}
                    </span>
                    &nbsp;|&nbsp;
                    {/* <span>{flight.cabinClass}</span> */}
                    <span>{allFareRules.cabinName}</span>
                    &nbsp;|&nbsp;
                    <span>
                      {moment(flight.departureTime).format('HH:mm')}
                      &nbsp;
                      <i
                        className={`fa-solid fa-arrow-right icon`}
                        style={{
                          fontSize: 12,
                        }}
                      />
                      &nbsp;
                      {moment(flight.arrivalTime).format('HH:mm')}
                    </span>
                  </div>
                </ItemLeg>
              );
            })}
            <div className="seeDetail" onClick={onClickViewDetailFlight}>
              {translations?.['b2c.text.see-detail']} &nbsp;
              <ArrowRightIcon />
            </div>
          </div>
        </CollapsePanelWrapper>
      </StyledCollapse>
      {!_.isEmpty(dataHotelInfo) && (
        <StyledCollapse defaultActiveKey="">
          <CollapsePanelWrapper
            style={{ marginTop: 10 }}
            className="collapseItem"
            key={1}
            header={
              <div className="boxLeftHeaderCollapse">
                <div className="boxIcon">
                  <BedIcon width={20} height={20} />
                </div>
                <div>
                  <Title>
                    {renderReplaceText(
                      translations?.['b2b.txt.hotelInLocation'],
                      {
                        name: formatShortAirport(dataFlight?.[0]?.arrival, true)
                          ?.cityName,
                      },
                    )}
                  </Title>
                  <SubTitle>
                    {' '}
                    {renderReplaceText(translations?.['b2b.txt.roomAndNight'], {
                      room: dataHotelInfo?.[0]?.numberOfRoom,
                      night: hotelNights,
                    })}
                  </SubTitle>
                </div>
              </div>
            }
          >
            <div className="boxContentCollapse">
              <BookingInfo>
                {`${formatDate(moment(checkin), translations)} - ${formatDate(
                  moment(checkout),
                  translations,
                )} | ${
                  +(firstHotel.adultQuantity || 0) +
                  +(firstHotel.childQuantity || 0)
                } ${translations?.['b2b.txt.passenger']}`}
              </BookingInfo>
              {dataHotelInfo?.map(item => {
                const firstRoomType = item?.detail?.roomTypes?.[0] || {};
                return (
                  <HotelCard key={item.hotelId}>
                    <HotelName>{item?.hotelName || ''}</HotelName>
                    <div className="d-flex gap-3">
                      <HotelImage
                        src={
                          firstRoomType?.mediaFiles?.[0]?.mediaUrl ||
                          FALLBACK_IMAGE
                        }
                        alt="hotel"
                        onError={handleImageError}
                      />
                      <HotelContent>
                        <RoomName>{`${item?.roomTypeName || ''} x ${
                          item?.numberOfRoom
                        }`}</RoomName>
                        <RoomMeta>
                          {renderReplaceText(
                            translations?.['b2b.txt.roomPackage'],
                            {
                              room: item.ratePlanName,
                            },
                          )}
                        </RoomMeta>
                      </HotelContent>
                    </div>
                  </HotelCard>
                );
              })}
              <div className="seeDetail" onClick={onClickViewDetailHotel}>
                {translations?.['b2c.text.see-detail']} &nbsp;
                <ArrowRightIcon />
              </div>
            </div>
          </CollapsePanelWrapper>
        </StyledCollapse>
      )}
      {!_.isEmpty(dataCombo) && (
        <StyledCollapse defaultActiveKey="">
          <CollapsePanelWrapper
            style={{ marginTop: 10 }}
            className="collapseItem"
            key={1}
            header={
              <div className="boxLeftHeaderCollapse">
                <div className="boxIcon">
                  <LeadingIcon width={20} height={20} />
                </div>
                <div>
                  <Title>
                    {translations?.['b2b.txt.sunWorldParkTicket'] || ''}
                  </Title>
                </div>
              </div>
            }
          >
            <div className="boxContentCollapse">
              {dataCombo?.map(item => {
                return (
                  <div className="boxContentCombo" key={item?.id}>
                    {/* <img
                src={dataCombo?.imageUrl || Images.ImgBanner}
                alt=""
                className="combo-img"
                onError={e => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = Images.ImgBanner;
                }}
              /> */}
                    <div className="infoCombo">
                      <div className="titleCombo">{item?.name}</div>
                      <div className="textQuantity">{`${translations?.[
                        'b2b.txt.quantityTicket'
                      ]?.replace('${quantity}', +item?.quantity || 0)}`}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </CollapsePanelWrapper>
        </StyledCollapse>
      )}
      {isShowInfo && (
        <DialogFlightInformation
          flights={dataFlight || []}
          isShow={isShowInfo}
          onCloseDialog={onCloseDialog}
        />
      )}
      {isShowHotelInfo && (
        <DialogHotelDetail
          hotels={dataHotelInfo || []}
          isShow={isShowHotelInfo}
          onCloseDialog={onCloseDialogHotel}
          note={note}
        />
      )}
    </BoxContainerCollapse>
  );
};
export default FlightInformation;
const BoxContainerCollapse = styled.div`
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;
  .collapseItem {
    border-radius: 8px !important;
    border: 1px solid #e5e5e5;
    overflow: hidden;
    .ant-collapse-header {
      padding-right: 12px !important;
      padding-top: 0px !important;
      height: 50px;
      background: #f2f2f2;
      .ant-collapse-arrow {
        right: 10px !important;
      }
    }
  }
  .boxLeftHeaderCollapse {
    height: 50px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .boxIcon {
    background: var(--color-gradient);
    min-height: 50px;
    height: 100%;
    min-width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .boxContentCollapse {
    background: #fff;
  }
  .seeDetail {
    color: var(--color-4);
    padding-left: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    &:hover {
      opacity: 0.8;
    }
  }
  .boxContentCombo {
    background: #f2f2f2;
    border-radius: 8px;
    padding: 10px;
    margin-left: 10px;
    margin-right: 10px;
    display: flex;
    align-items: center;
  }
  .combo-img {
    width: 36px;
    height: 36px;
    object-fit: cover;
    border-radius: 8px;
  }
  .infoCombo {
    margin-left: 10px;
  }
  .titleCombo {
    font-size: 12px;
    font-weight: 600;
  }
  .textQuantity {
    font-size: 12px;
  }
  @media (max-width: 768px) {
    .comboCollapseMobile {
      .ant-collapse-header {
        height: 72px !important;
      }
      .boxLeftHeaderCollapse {
        height: 72px;
      }
      .boxIcon {
        min-height: 72px;
      }
    }
  }
`;
const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
`;
const SubTitle = styled.div`
  font-size: 10px;
`;
const ItemLeg = styled.div`
  display: flex;
  margin-bottom: 6px;
  padding: 0 10px;
  font-size: 14px;
  align-items: center;
  .txtLeg {
    color: var(--color-9);
    min-width: 80px;
    font-weight: 600;
    flex-shrink: 0;
  }
  .legContent {
    display: inline;
    line-height: 1.4;
  }
  .icon {
    display: inline;
    margin: 0 4px;
    font-size: 12px;
    vertical-align: middle;
  }
`;
const BookingInfo = styled.div`
  font-size: 14px;
  margin-bottom: 6px;
  margin-left: 10px;
  margin-right: 10px;
`;
const HotelCard = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #f8f8f8;
  border-radius: 8px;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
  margin-left: 10px;
  margin-right: 10px;
`;
const HotelImage = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
`;
const HotelContent = styled.div`
  flex: 1;
  min-width: 0;
`;
const HotelName = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #000;
`;
const RoomName = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #222;
`;
const RoomMeta = styled.div`
  font-size: 12px;
  color: #777;
`;
